/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_TitleInputs */

const en_auth_ground_title = /** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients, projects, time and invoices in one calm place.`)
};

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const ar_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const he_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const ur_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const es_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const fr_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const de_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const pt_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const hi_auth_ground_title = en_auth_ground_title;

/** @type {(inputs: Auth_Ground_TitleInputs) => LocalizedString} */
const bn_auth_ground_title = en_auth_ground_title;

/**
* | output |
* | --- |
* | "Clients, projects, time and invoices in one calm place." |
*
* @param {Auth_Ground_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_title = /** @type {((inputs?: Auth_Ground_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_title(inputs)
	if (locale === "he") return he_auth_ground_title(inputs)
	if (locale === "ur") return ur_auth_ground_title(inputs)
	if (locale === "es") return es_auth_ground_title(inputs)
	if (locale === "fr") return fr_auth_ground_title(inputs)
	if (locale === "de") return de_auth_ground_title(inputs)
	if (locale === "pt") return pt_auth_ground_title(inputs)
	if (locale === "hi") return hi_auth_ground_title(inputs)
	if (locale === "bn") return bn_auth_ground_title(inputs)
	return /** @type {LocalizedString} */ ("Clients, projects, time and invoices in one calm place.")
});